export enum FormFieldCustomComponentTypes {
    DisplayText = 'display-text',
    TextField =  'text-field',
    Switch =  'switch',
    Select= 'select',
    CustomNumericField = 'custom-numeric-field',
    CustomAutoComplete ='custom-auto-complete',
    CustomStandardSelect = 'custom-standard-select',
    CustomTransferList =  'custom-transfer-list',
    CustomAutoCompleteMultiple = 'custom-auto-complete-multiple',
    AutoComplete ='autocomplete',
    PasswordField = 'custom-password-field',
    CustomDateTimePicker = 'custom-date-time-picker'
}
